module.exports = __webpack_public_path__ + "img/ep6-5.3f6f41f3.png";